function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.58631 14.2451C5.36575 16.0141 8.46904 18.4662 11.9997 18.4662C15.5303 18.4662 18.6331 16.0141 20.4125 14.2451C20.8818 13.7786 21.1172 13.5445 21.2667 13.0864C21.3733 12.7596 21.3733 12.173 21.2667 11.8462C21.1172 11.3881 20.8818 11.154 20.4125 10.6874C18.633 8.91839 15.5303 6.46631 11.9997 6.46631C8.46904 6.46631 5.36575 8.91839 3.58631 10.6874C3.11665 11.1543 2.8818 11.388 2.73231 11.8462C2.62569 12.173 2.62569 12.7596 2.73231 13.0864C2.8818 13.5447 3.11665 13.7782 3.58631 14.2451Z",
  stroke: "#707274",
  strokeOpacity: 0.65,
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.99951 12.4663C9.99951 13.5709 10.8949 14.4663 11.9995 14.4663C13.1041 14.4663 13.9995 13.5709 13.9995 12.4663C13.9995 11.3617 13.1041 10.4663 11.9995 10.4663C10.8949 10.4663 9.99951 11.3617 9.99951 12.4663Z",
  stroke: "#707274",
  strokeOpacity: 0.65,
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/Show.e66431e9.svg";
export { ForwardRef as ReactComponent };